import React, { useContext } from 'react';
import { SideNavigation, TopButton } from '../components';
import { SideNavContext } from '../contexts';
import Header from '../components/header/Header';
import RentalService from '../components/rentalService/RentalService';

const RentalServicePage = () => {

    const { isSideNavOpen } = useContext(SideNavContext);
    
    return (
        <>
            {isSideNavOpen && <SideNavigation />}

            <Header />

            <main>
                <RentalService />
            </main>

            <TopButton />
        </>
    );
};

export default RentalServicePage;